import { render } from "./SigneUpConfirmForm.vue?vue&type=template&id=73ae3db0&scoped=true"
import script from "./SigneUpConfirmForm.vue?vue&type=script&lang=js"
export * from "./SigneUpConfirmForm.vue?vue&type=script&lang=js"

import "./SigneUpConfirmForm.vue?vue&type=style&index=0&id=73ae3db0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73ae3db0"

export default script